/*
 *
 * EasySplitSettlements reducer
 *
 */
import produce from 'immer';
import moment from 'moment';

import {
  CURRENCY_SYMBOL,
  DATE_AND_TIME_FORMAT,
  DEFAULT_CURRENT_PAGE,
  DEFAULT_PG_MENU_TAB_STATE,
} from 'utils/constants';

import {
  DEFAULT_ACTION,
  FETCH_LIVE_SETTLEMENT,
  RESET_FILTERS,
  RESET_PAGE,
  SAVE_LIVE_SETTLEMENT,
  SAVE_TRANSFER_BALANCE_SUCCESS,
  UPDATE_FILTERS,
} from './constants';

export const initialState = {
  isLoading: false,
  ...DEFAULT_PG_MENU_TAB_STATE,
  DEFAULT_PG_MENU_TAB_STATE,
  transferBalanceSuccessInfo: {},
};

/* eslint-disable default-case, no-param-reassign */
const easySplitSettlementsReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case DEFAULT_ACTION:
        break;
      case UPDATE_FILTERS: {
        const {
          activeNavigation,

          appliedFilters: appliedFilter = {},
          filtersForDisplay = [],
          ...filters
        } = action.data;

        if (appliedFilter) draft.filters.appliedFilters = appliedFilter;

        draft.filters = {
          ...draft.filters,
          ...filters,
        };

        if (filtersForDisplay) draft.filtersForDisplay = filtersForDisplay;
        break;
      }
      case RESET_FILTERS: {
        const { filters } = initialState;
        draft.filters = filters;
        draft.filtersForDisplay = [];
        break;
      }
      case RESET_PAGE: {
        draft.filters.pageNo = DEFAULT_CURRENT_PAGE;
        break;
      }
      case SAVE_TRANSFER_BALANCE_SUCCESS: {
        const { charges } = action.data;
        const { serviceCharges, serviceTax, amount } = charges;
        const additionalCharges = serviceCharges + serviceTax;
        draft.transferBalanceSuccessInfo = {
          additionalCharges: `${CURRENCY_SYMBOL.INR} ${additionalCharges}`,
          amount: `${CURRENCY_SYMBOL.INR} ${amount}`,
          initiatedAt: moment().format(DATE_AND_TIME_FORMAT),
        };
      }
    }
  });

export const liveSettlementReducer = (state, { type, data }) =>
  produce(state, draft => {
    switch (type) {
      case SAVE_LIVE_SETTLEMENT:
        draft.settlementList = data;
        draft.loading = false;
        break;
      case FETCH_LIVE_SETTLEMENT:
        draft.settlementList = {};
        draft.loading = true;
        break;
      default:
        break;
    }
  });

export default easySplitSettlementsReducer;
